var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 160,
    viewBox: "0 0 375 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_133_5063",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 160
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 160,
    fill: "#F5F7FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_133_5063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.223 114.385C91.926 116.201 94.629 117.11 97.332 118.018C95.53 125.285 87.421 126.193 82.015 129.827C81.114 130.735 81.114 132.552 80.213 133.46C78.411 129.827 76.609 127.102 77.51 123.468C77.51 119.835 82.916 118.926 86.52 117.11C87.421 116.201 88.322 115.293 89.223 114.385Z",
    fill: "#5D1CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9442 25.3638C20.7462 26.2722 21.6472 26.2722 23.4492 26.2722C22.5482 28.9972 21.6472 32.6307 18.9442 33.539C13.5382 34.4474 8.1322 37.1725 6.3302 42.6226C1.8252 34.4474 9.93421 30.814 16.2412 28.0889C17.1422 27.1805 18.0432 26.2722 18.9442 25.3638Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.748 122.374C255.451 125.099 259.956 126.916 259.055 130.549C259.055 135.999 251.847 136.908 248.243 141.45C247.342 142.358 247.342 143.266 247.342 144.175C244.639 140.541 241.936 135.999 242.837 131.458C243.738 126.916 250.946 128.733 252.748 122.374Z",
    fill: "#40AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6992 152.808C55.6992 155.533 55.6992 158.258 53.8972 160.075C52.9962 160.075 50.2932 159.167 49.3922 158.258C48.4912 153.716 44.8872 157.35 43.9862 153.716C46.6892 152.808 49.3922 152.808 52.9962 153.716C53.8972 153.716 54.7982 152.808 55.6992 152.808Z",
    fill: "#FF8F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.737 151.172C295.638 152.989 298.341 155.714 297.44 156.623C294.737 161.164 289.331 156.623 284.826 157.531C283.925 158.439 282.123 159.348 281.222 160.256C281.222 156.623 281.222 153.897 281.222 150.264C285.727 148.447 290.232 150.264 294.737 151.172Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.084 121.649C183.282 120.741 182.381 120.741 180.579 120.741C179.678 115.291 185.084 113.474 187.787 109.841C188.688 108.932 188.688 107.116 188.688 106.207C190.49 108.024 191.391 110.749 191.391 113.474C190.49 115.291 187.787 117.108 185.985 118.924C185.084 119.833 185.084 120.741 185.084 121.649Z",
    fill: "#5D1CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19141 110.567C-0.610591 113.292 -3.31359 115.109 -5.11559 117.834C-6.91759 115.109 -9.62058 113.292 -10.5216 109.659C-11.4226 107.842 -11.4226 105.117 -13.2246 103.3C-11.4226 102.392 -9.62058 100.575 -8.71958 98.7585C-6.01658 100.575 -4.21459 103.3 -2.41259 106.025C-1.51159 107.842 -1.51159 109.659 1.19141 110.567Z",
    fill: "#FF2B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0928 172.339C91.2908 171.43 88.5878 170.522 88.5878 168.705C87.6868 164.163 93.0928 162.347 94.8948 158.713C96.6968 160.53 98.4988 162.347 100.301 163.255C98.4988 165.98 96.6968 167.797 93.9938 169.613C93.0928 170.522 93.0928 171.43 93.0928 172.339Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.935 130.552C140.034 130.552 139.133 131.46 138.232 132.369C136.43 127.827 138.232 123.285 139.133 118.743C139.133 117.835 138.232 116.018 138.232 115.11C141.836 116.018 145.44 116.018 147.242 119.652C147.242 120.56 146.341 123.285 145.44 124.193C143.638 126.01 141.836 127.827 140.935 130.552Z",
    fill: "#FF2B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.14 63.3319C227.338 59.6984 231.843 57.8817 230.942 54.2483C235.447 52.4316 238.15 56.9734 241.754 58.7901C242.655 58.7901 243.556 58.7901 244.457 58.7901C242.655 61.5152 241.754 65.1486 239.952 66.057C236.348 67.8737 233.645 62.4235 229.14 63.3319Z",
    fill: "#5D1CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.368 87.8587C253.467 85.1336 255.269 82.4085 255.269 79.6834C261.576 77.8667 265.18 83.3169 270.586 84.2252C269.685 87.8587 266.982 90.5838 264.279 92.4005C262.477 94.2172 258.873 91.4921 257.071 88.767C256.17 87.8587 255.269 87.8587 254.368 87.8587Z",
    fill: "#FF2B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.206 79.684C286.81 78.7756 289.513 81.5007 293.117 80.5923C291.315 86.0425 288.612 92.401 283.206 93.3094C282.305 88.7676 285.008 84.2258 283.206 79.684Z",
    fill: "#40AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.489 67.8751C364.291 68.7835 366.093 70.6002 367.895 70.6002C366.093 76.0504 361.588 76.9587 357.083 79.6838C356.182 80.5922 356.182 81.5005 355.281 82.4089C353.479 80.5922 350.776 78.7754 350.776 77.8671C349.875 73.3253 357.083 73.3253 360.687 70.6002C361.588 69.6918 361.588 68.7835 362.489 67.8751Z",
    fill: "#40AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 106.027C46.2402 107.843 47.1412 111.477 46.2402 111.477C41.7352 115.11 38.1312 109.66 35.4282 106.027C34.5272 105.118 32.7252 105.118 31.8242 105.118C35.4282 100.576 39.9332 101.485 43.5372 106.027C44.4382 106.027 45.3392 106.027 46.2402 106.027Z",
    fill: "#FF8F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.751 94.2173C323.751 90.5839 326.454 86.9505 325.553 82.4087C330.959 81.5003 336.365 82.4087 341.771 85.1337C343.573 86.0421 346.276 85.1337 348.078 83.317C347.177 86.9505 346.276 90.5839 342.672 92.4006C336.365 94.2173 329.157 87.8588 323.751 94.2173Z",
    fill: "#5D1CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.676 49.7066C350.775 50.6149 350.775 51.5233 349.874 52.4316C348.072 47.8898 351.676 45.1648 349.874 40.623C352.577 40.623 354.379 40.623 357.082 40.623C357.082 42.4397 357.082 44.2564 356.181 45.1648C354.379 46.0731 352.577 47.8898 351.676 49.7066Z",
    fill: "#5D1CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1889 139.362L13.4414 143.177L7.22452 146.901L4.97202 142.995L11.1889 139.362Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9591 64.8775L28.671 62.1524L33.0859 64.8775L31.4641 67.6025L26.9591 64.8775Z",
    fill: "#FF8F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9209 114.201L63.6328 116.472L59.9387 119.378L58.1367 117.017L61.9209 114.201Z",
    fill: "#50E3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2707 78.6852L85.6133 82.3187L79.6667 86.1338L77.4142 82.4095L83.2707 78.6852Z",
    fill: "#5D1CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.905 153.35L114.806 150.171L119.941 151.624L119.04 154.803L113.905 153.35Z",
    fill: "#50E3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.537 84.4985L176.348 88.7678L169.41 90.1303L168.599 85.7702L175.537 84.4985Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.457 66.0598L210.854 63.9706L214.188 74.5075L207.79 76.5059L204.457 66.0598Z",
    fill: "#FF2B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.708 114.836L330.051 117.289L326.086 121.104L323.744 118.651L327.708 114.836Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.851 94.8536L345.194 91.9468L349.879 95.8528L347.536 98.7595L342.851 94.8536Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.403 163.171L176.809 163.151L176.777 154.249L171.371 154.269L171.403 163.171Z",
    fill: "#50E3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6989 81.1397L41.5555 77.9605L46.7813 87.6799L40.9247 90.95L35.6989 81.1397Z",
    fill: "#FF8F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7905 124.556L57.3221 120.741L63.5391 123.284L62.0074 127.1L55.7905 124.556Z",
    fill: "#5D1CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6242 62.242L94.8945 65.9663L88.9479 66.4205L88.6776 62.6962L94.6242 62.242Z",
    fill: "#50E3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.464 91.9453L104.536 84.4059L116.609 87.8577L114.537 95.3062L102.464 91.9453Z",
    fill: "#5D1CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.812 154.26L221.939 151.989L225.543 162.072L219.416 164.343L215.812 154.26Z",
    fill: "#5D1CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.954 79.1396L257.973 81.5014L254.188 94.6726L246.17 92.3109L249.954 79.1396Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 128.551L341.406 135.273L330.594 144.175L325.098 137.453L336 128.551Z",
    fill: "#40AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.133 155.624L376.277 159.62L369.79 166.433L365.646 162.436L372.133 155.624Z",
    fill: "#FF2B90"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/Confetti.1d7ff900cd8417cfed04eb607e3e9a0e.svg";
export { ForwardRef as ReactComponent };